export const attr = (container: HTMLElement, name: string, fallback = ""): string =>
  container.getAttribute(name) || fallback;

export const bool = (container: HTMLElement, name: string, fallback = false): boolean => {
  const v = container.getAttribute(name);
  if (v == null) return fallback;
  return v === "true";
};

export const jsonArrayAttr = (container: HTMLElement, name: string, logLabel?: string): string[] => {
  const v = container.getAttribute(name);
  if (!v) return [];
  try {
    return JSON.parse(v);
  } catch (e) {
    console.error(`[${logLabel ?? "widget"}] parse error for ${name}:`, e);
    return [];
  }
};

export const jsonObjectAttr = (container: HTMLElement, name: string): Record<string, unknown> => {
  const value = container.getAttribute(name);
  if (!value) return {};
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
};
